import { Map as ImmutableMap, Record as ImmutableRecord } from 'immutable';
import getIn from 'immutable-less/transmute/getIn';
import setIn from 'immutable-less/transmute/setIn';
import { CREATE, DELETE, UPDATE } from 'automation-ui-action-features/actions/custom-code/constants/updateTypes';
import OutputFieldKeys from 'automation-ui-action-features/action-outputs/records/OutputFieldKeys';
import OutputTypeDefinition from 'automation-ui-flow-core/fields/OutputTypeDefinition';
export default class OutputField extends ImmutableRecord({
  [OutputFieldKeys.OUTPUT_FIELD_DEFINITION]: ImmutableMap({
    [OutputFieldKeys.TYPE_DEFINITION]: new OutputTypeDefinition({})
  }),
  [OutputFieldKeys.UPDATE_TYPE]: CREATE
}, 'OutputField') {
  constructor(options = {}) {
    let optionMap = ImmutableMap(options);
    const typeDefinition = getIn([OutputFieldKeys.OUTPUT_FIELD_DEFINITION, OutputFieldKeys.TYPE_DEFINITION], optionMap);
    const outputTypeDefinition = new OutputTypeDefinition(typeDefinition);
    const outputFieldDefinition = ImmutableMap({
      typeDefinition: outputTypeDefinition
    });
    optionMap = optionMap.set(OutputFieldKeys.OUTPUT_FIELD_DEFINITION, outputFieldDefinition);
    super(optionMap);
  }
  getOutputTypeDefinition() {
    return getIn([OutputFieldKeys.OUTPUT_FIELD_DEFINITION, OutputFieldKeys.TYPE_DEFINITION], this);
  }
  setOutputTypeDefinition(typeDefinition) {
    const outputTypeDefinition = new OutputTypeDefinition(typeDefinition);
    return setIn([OutputFieldKeys.OUTPUT_FIELD_DEFINITION, OutputFieldKeys.TYPE_DEFINITION], outputTypeDefinition, this);
  }
  getUpdateType() {
    return getIn([OutputFieldKeys.UPDATE_TYPE], this);
  }
  setUpdateType(updateType) {
    return setIn([OutputFieldKeys.UPDATE_TYPE], updateType, this);
  }
  isPendingDeletion() {
    return this.getUpdateType() === DELETE;
  }
  hasBeenSaved() {
    return this.getUpdateType() === UPDATE;
  }
}